(function (global) {
  var MAX_EVENTS = 200;
  var MAX_ERRORS = 100;
  var MAX_STAGE_HISTORY = 20;

  function nowIso() {
    return new Date().toISOString();
  }

  function detectPage() {
    try {
      var path = (global.location && global.location.pathname ? global.location.pathname : "").toLowerCase();
      if (path.indexOf("taskpane") !== -1) {
        return "taskpane";
      }
      if (path.indexOf("commands") !== -1) {
        return "command-file";
      }
      if (path.indexOf("index") !== -1) {
        return "runtime";
      }
      return "unknown";
    } catch (_) {
      return "unknown";
    }
  }

  function normalizeAddinVersion(value) {
    if (!value) {
      return null;
    }

    var normalized = String(value).trim().toLowerCase();
    if (normalized === "1" || normalized === "v1") {
      return "v1";
    }
    if (normalized === "2" || normalized === "v2") {
      return "v2";
    }
    return normalized;
  }

  function readQueryParam(name) {
    try {
      var search = global.location && global.location.search ? global.location.search.replace(/^\?/, "") : "";
      if (!search) {
        return null;
      }

      var parts = search.split("&");
      for (var i = 0; i < parts.length; i += 1) {
        var pair = parts[i].split("=");
        if (decodeURIComponent(pair[0] || "") === name) {
          return decodeURIComponent((pair[1] || "").replace(/\+/g, " "));
        }
      }
    } catch (_) {
      return null;
    }

    return null;
  }

  function getClientInfo() {
    var version = normalizeAddinVersion(readQueryParam("addinVersion")) || "v1";
    var manifestVersion = readQueryParam("manifestVersion");
    return {
      version: version,
      manifestVersion: manifestVersion || null,
      page: detectPage(),
      href: global.location ? global.location.href : null,
    };
  }

  var clientInfo = getClientInfo();
  var STORAGE_KEY = "admail:diagnostics:" + clientInfo.version;
  var SETTINGS_KEY = "admail:settings:" + clientInfo.version;
  var ADDIN_NAME = clientInfo.manifestVersion ? "Admail for Outlook " + clientInfo.manifestVersion : "Admail for Outlook";

  function normalizeSignatureLanguagePreference(value) {
    if (!value) {
      return "default";
    }

    var normalized = String(value).trim().toLowerCase();
    if (normalized === "he" || normalized === "en") {
      return normalized;
    }

    return "default";
  }

  function normalizeTenantAccessKey(value) {
    if (!value) {
      return "";
    }

    return String(value).trim();
  }

  function readSettings() {
    try {
      var raw = global.localStorage ? global.localStorage.getItem(SETTINGS_KEY) : null;
      if (!raw) {
        return {
          signatureLanguagePreference: "default",
          tenantAccessKey: "",
        };
      }

      var parsed = JSON.parse(raw);
      return {
        signatureLanguagePreference: normalizeSignatureLanguagePreference(parsed && parsed.signatureLanguagePreference),
        tenantAccessKey: normalizeTenantAccessKey(parsed && parsed.tenantAccessKey),
      };
    } catch (_) {
      return {
        signatureLanguagePreference: "default",
        tenantAccessKey: "",
      };
    }
  }

  function writeSettings(settings) {
    var current = readSettings();
    var next = {
      signatureLanguagePreference: normalizeSignatureLanguagePreference(settings && Object.prototype.hasOwnProperty.call(settings, "signatureLanguagePreference")
        ? settings.signatureLanguagePreference
        : current.signatureLanguagePreference),
      tenantAccessKey: normalizeTenantAccessKey(settings && Object.prototype.hasOwnProperty.call(settings, "tenantAccessKey")
        ? settings.tenantAccessKey
        : current.tenantAccessKey),
    };

    try {
      if (global.localStorage) {
        global.localStorage.setItem(SETTINGS_KEY, JSON.stringify(next));
      }
    } catch (_) {
      // Ignore storage failures.
    }

    try {
      if (typeof global.dispatchEvent === "function" && typeof global.CustomEvent === "function") {
        global.dispatchEvent(
          new global.CustomEvent("admail:settings", {
            detail: clone(next),
          })
        );
      }
    } catch (_) {
      // Ignore event failures.
    }

    return clone(next);
  }

  function sanitizeValue(value, depth, seen) {
    if (depth > 4) {
      return "[max-depth]";
    }

    if (value === null || value === undefined) {
      return value;
    }

    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
      return value;
    }

    if (value instanceof Date) {
      return value.toISOString();
    }

    if (value instanceof Error) {
      return {
        name: value.name,
        message: value.message,
        stack: value.stack,
        code: value.code,
      };
    }

    if (typeof value === "function") {
      return "[function]";
    }

    if (seen.indexOf(value) !== -1) {
      return "[circular]";
    }

    seen.push(value);

    if (Object.prototype.toString.call(value) === "[object Array]") {
      var arrayResult = [];
      for (var index = 0; index < value.length && index < 25; index += 1) {
        arrayResult.push(sanitizeValue(value[index], depth + 1, seen));
      }
      return arrayResult;
    }

    var result = {};
    var keys = Object.keys(value);
    for (var i = 0; i < keys.length && i < 30; i += 1) {
      var key = keys[i];
      try {
        result[key] = sanitizeValue(value[key], depth + 1, seen);
      } catch (_) {
        result[key] = "[unavailable]";
      }
    }
    return result;
  }

  function clone(value) {
    return sanitizeValue(value, 0, []);
  }

  function createState() {
    return {
      schemaVersion: 1,
      addInName: ADDIN_NAME,
      clientInfo: clone(clientInfo),
      updatedAt: null,
      stages: {},
      environment: {},
      events: [],
      errors: [],
    };
  }

  function readState() {
    try {
      var raw = global.localStorage ? global.localStorage.getItem(STORAGE_KEY) : null;
      if (!raw) {
        return createState();
      }

      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== "object") {
        return createState();
      }

      return {
        schemaVersion: parsed.schemaVersion || 1,
        addInName: parsed.addInName || ADDIN_NAME,
        clientInfo: parsed.clientInfo || clone(clientInfo),
        updatedAt: parsed.updatedAt || null,
        stages: parsed.stages || {},
        environment: parsed.environment || {},
        events: parsed.events || [],
        errors: parsed.errors || [],
      };
    } catch (_) {
      return createState();
    }
  }

  function writeState(state) {
    state.updatedAt = nowIso();

    try {
      if (global.localStorage) {
        global.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      }
    } catch (_) {
      // Ignore storage failures. The panel can still use the in-page state.
    }

    try {
      if (typeof global.dispatchEvent === "function" && typeof global.CustomEvent === "function") {
        global.dispatchEvent(
          new global.CustomEvent("admail:diagnostics", {
            detail: clone(state),
          })
        );
      }
    } catch (_) {
      // Ignore event dispatch failures.
    }
  }

  function appendBounded(list, value, maxSize) {
    var next = list ? list.slice() : [];
    next.push(value);
    if (next.length > maxSize) {
      next = next.slice(next.length - maxSize);
    }
    return next;
  }

  function updateState(mutator) {
    var state = readState();
    mutator(state);
    writeState(state);
    return clone(state);
  }

  function markStage(id, payload) {
    var nextPayload = payload || {};
    var source = nextPayload.source || detectPage();

    return updateState(function (state) {
      var previous = state.stages[id] || {
        id: id,
        label: nextPayload.label || id,
        status: "pending",
        source: source,
        details: null,
        updatedAt: null,
        history: [],
      };

      var updatedAt = nowIso();
      var details = clone(nextPayload.details);
      var stage = {
        id: id,
        label: nextPayload.label || previous.label || id,
        status: nextPayload.status || previous.status || "pending",
        source: source,
        details: details === undefined ? previous.details : details,
        updatedAt: updatedAt,
        startedAt: previous.startedAt || (nextPayload.status === "running" ? updatedAt : null),
        completedAt: previous.completedAt || (nextPayload.status === "completed" ? updatedAt : null),
        failedAt: previous.failedAt || (nextPayload.status === "failed" ? updatedAt : null),
        history: appendBounded(
          previous.history,
          {
            status: nextPayload.status || previous.status || "pending",
            source: source,
            updatedAt: updatedAt,
            details: details,
          },
          MAX_STAGE_HISTORY
        ),
      };

      if (nextPayload.status === "running" && !stage.startedAt) {
        stage.startedAt = updatedAt;
      }
      if (nextPayload.status === "completed") {
        stage.completedAt = updatedAt;
        stage.failedAt = null;
      }
      if (nextPayload.status === "failed") {
        stage.failedAt = updatedAt;
      }

      state.stages[id] = stage;
    });
  }

  function log(level, message, data, source) {
    var event = {
      id: nowIso() + "-" + Math.round(Math.random() * 1000000),
      level: level || "info",
      message: message,
      source: source || detectPage(),
      createdAt: nowIso(),
      data: clone(data),
    };

    return updateState(function (state) {
      state.events = appendBounded(state.events, event, MAX_EVENTS);
    });
  }

  function recordError(area, error, data, source) {
    var serializedError = clone(error);
    var entry = {
      id: nowIso() + "-" + Math.round(Math.random() * 1000000),
      area: area,
      source: source || detectPage(),
      createdAt: nowIso(),
      error: serializedError,
      data: clone(data),
    };

    return updateState(function (state) {
      state.errors = appendBounded(state.errors, entry, MAX_ERRORS);
      state.events = appendBounded(
        state.events,
        {
          id: entry.id,
          level: "error",
          message: area,
          source: entry.source,
          createdAt: entry.createdAt,
          data: {
            error: serializedError,
            context: entry.data,
          },
        },
        MAX_EVENTS
      );
    });
  }

  function setEnvironment(scope, data, source) {
    return updateState(function (state) {
      state.environment[scope] = {
        scope: scope,
        source: source || detectPage(),
        updatedAt: nowIso(),
        data: clone(data),
      };
    });
  }

  function clear() {
    var state = createState();
    writeState(state);
    return clone(state);
  }

  var api = {
    storageKey: STORAGE_KEY,
    settingsKey: SETTINGS_KEY,
    clear: clear,
    getClientInfo: function () {
      return clone(clientInfo);
    },
    getSettings: function () {
      return clone(readSettings());
    },
    getSignatureLanguagePreference: function () {
      return readSettings().signatureLanguagePreference;
    },
    setSignatureLanguagePreference: function (value) {
      return writeSettings({
        signatureLanguagePreference: value,
      }).signatureLanguagePreference;
    },
    getTenantAccessKey: function () {
      return readSettings().tenantAccessKey;
    },
    setTenantAccessKey: function (value) {
      return writeSettings({
        tenantAccessKey: value,
      }).tenantAccessKey;
    },
    getSnapshot: function () {
      return clone(readState());
    },
    log: log,
    markStage: markStage,
    recordError: recordError,
    setEnvironment: setEnvironment,
  };

  global.AdmailDiagnostics = api;

  if (typeof global.addEventListener === "function") {
    global.addEventListener("error", function (event) {
      api.recordError(
        "window.onerror",
        event && event.error ? event.error : { message: event && event.message ? event.message : "Unknown error" },
        {
          filename: event && event.filename,
          lineno: event && event.lineno,
          colno: event && event.colno,
        },
        detectPage()
      );
    });

    global.addEventListener("unhandledrejection", function (event) {
      api.recordError(
        "unhandledrejection",
        event ? event.reason : { message: "Unhandled promise rejection" },
        null,
        detectPage()
      );
    });
  }

  api.log("info", "Diagnostics runtime loaded", clone(clientInfo));
})(typeof window !== "undefined" ? window : this);
